<template>
  <Header />
  <Herosection />
  <Reflection />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Herosection from "@/components/HeroSectionPage.vue";
import Footer from "@/components/Footer.vue";
import Reflection from "@/components/views/Reflection.vue";

export default {
  components: {
    Header,
    Herosection,
    Footer,
    Reflection,
  },
};
</script>
